/* ============================================================
   Auto currency converter — display only.
   - Detects visitor's country via IP geolocation.
   - Converts and REPLACES displayed prices with ONLY the local
     currency (no USD shown alongside), using live daily
     exchange rates.
   - Never touches the real checkout: Shopify's actual checkout
     runs on its own separate, Shopify-hosted flow this script
     cannot reach.
   - Fails silently on lookup errors.

   FIXED (second bug): price elements can now contain a nested
   <s> strikethrough tag for sale pricing (e.g.
   "$57.75 <s>$105.00</s>"). The previous version set
   el.textContent on the whole container, which silently deleted
   the <s> tag and collapsed both numbers into one confusing
   value. Now converts the sale price and the strikethrough
   original separately, preserving the actual DOM structure.
   ============================================================ */
(function () {
  'use strict';

  var CACHE_KEY = 'tg_currency_v1';
  var CACHE_TTL_MS = 1000 * 60 * 60 * 24;

  var COUNTRY_CURRENCY = {
    IN: 'INR', AE: 'AED', AT: 'EUR', AU: 'AUD', BE: 'EUR',
    GB: 'GBP', FR: 'EUR', DE: 'EUR', JP: 'JPY', CA: 'CAD',
    NL: 'EUR', ES: 'EUR', IT: 'EUR', SG: 'SGD', NZ: 'NZD',
    CH: 'CHF', SE: 'SEK', NO: 'NOK', DK: 'DKK', SA: 'SAR',
    QA: 'QAR', KW: 'KWD', ZA: 'ZAR', MX: 'MXN', BR: 'BRL'
  };

  var SYMBOL = {
    INR: '₹', AED: 'AED ', EUR: '€', AUD: 'A$', GBP: '£',
    JPY: '¥', CAD: 'C$', SGD: 'S$', NZD: 'NZ$', CHF: 'CHF ',
    SEK: 'kr ', NOK: 'kr ', DKK: 'kr ', SAR: 'SAR ', QAR: 'QAR ',
    KWD: 'KWD ', ZAR: 'R', MXN: 'MX$', BRL: 'R$', USD: '$'
  };

  function getCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (Date.now() - data.timestamp > CACHE_TTL_MS) return null;
      return data;
    } catch (e) { return null; }
  }

  function setCache(data) {
    try {
      data.timestamp = Date.now();
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(data));
    } catch (e) {}
  }

  function detectCountry() {
    return fetch('https://ipwho.is/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.success || !data.country_code) return null;
        return data.country_code;
      })
      .catch(function () { return null; });
  }

  function fetchRate(targetCurrency) {
    return fetch('https://open.er-api.com/v6/latest/USD')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || data.result !== 'success' || !data.rates || !data.rates[targetCurrency]) return null;
        return data.rates[targetCurrency];
      })
      .catch(function () { return null; });
  }

  function formatConverted(amountUsd, rate, currency) {
    var converted = amountUsd * rate;
    var symbol = SYMBOL[currency] || (currency + ' ');
    var rounded = converted >= 100 ? Math.round(converted) : converted.toFixed(2);
    return symbol + rounded.toLocaleString();
  }

  function extractAmount(text) {
    var match = text.replace(/,/g, '').match(/[\d.]+/);
    if (!match) return null;
    var amount = parseFloat(match[0]);
    return isNaN(amount) ? null : amount;
  }

  function convertTextNode(node, rate, currency) {
    var original = node.getAttribute && node.getAttribute('data-usd-original');
    if (original === null || original === undefined) return;
    var amount = extractAmount(original);
    if (amount === null) return;
    var next = formatConverted(amount, rate, currency);
    if (node.textContent === next) return;
    node.textContent = next;
  }

  function prepareAndConvertPriceElement(el, rate, currency) {
    if (!el.hasAttribute('data-tg-price-prepared')) {
      var sEl = el.querySelector('s');
      var sText = sEl ? sEl.textContent.trim() : null;

      var mainText = '';
      el.childNodes.forEach(function (n) {
        if (n.nodeType === Node.TEXT_NODE) mainText += n.textContent;
      });
      mainText = mainText.trim();

      var mainSpan = document.createElement('span');
      mainSpan.className = 'tg-price-main';
      mainSpan.setAttribute('data-usd-original', mainText);
      mainSpan.textContent = mainText;

      el.textContent = '';
      el.appendChild(mainSpan);
      if (sEl && sText) {
        el.appendChild(document.createTextNode(' '));
        sEl.setAttribute('data-usd-original', sText);
        sEl.textContent = sText;
        el.appendChild(sEl);
      }
      el.setAttribute('data-tg-price-prepared', 'true');
    }

    var mainSpan = el.querySelector('.tg-price-main');
    var sEl = el.querySelector('s');
    if (mainSpan) convertTextNode(mainSpan, rate, currency);
    if (sEl) convertTextNode(sEl, rate, currency);
  }

  function applyConversion(rate, currency) {
    var selectors = ['.tg-price', '.tg-pdp-price', '.tg-cd-price', '[data-cd-sub]'];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        prepareAndConvertPriceElement(el, rate, currency);
      });
    });
  }

  function wireUpTargetedRechecks(rate, currency) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-bag-icon]') || e.target.closest('.tg-add-btn') || e.target.closest('.tg-stick-add')) {
        setTimeout(function () { applyConversion(rate, currency); }, 400);
      }
    });
  }

  function init() {
    var cached = getCache();
    if (cached && cached.currency && cached.rate) {
      if (cached.currency !== 'USD') {
        applyConversion(cached.rate, cached.currency);
        wireUpTargetedRechecks(cached.rate, cached.currency);
      }
      return;
    }

    detectCountry().then(function (countryCode) {
      if (!countryCode) return;
      var currency = COUNTRY_CURRENCY[countryCode];
      if (!currency || currency === 'USD') {
        setCache({ currency: 'USD', rate: 1 });
        return;
      }
      fetchRate(currency).then(function (rate) {
        if (!rate) return;
        setCache({ currency: currency, rate: rate });
        applyConversion(rate, currency);
        wireUpTargetedRechecks(rate, currency);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
